import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const TYPES_BY_SIZE = ['Baby-cape', 'Capesize', 'Handysize', 'Handymax',
	'Kamsarmax', 'Newcastlemax', 'Panamax', 'Post-panamax', 'Supramax',
	'Ultramax', 'Valemax', 'Vloc', 'Aframax', 'Amur', 'Large Modern Ecotype',
	'Omskiy', 'Sibirskiy', 'Suezmax', 'Volgo Balt', 'Volgo Don', 'Sokol'];

class TypeBySize extends React.Component {
    onChange = value => {
        const { changeField } = this.props;
        changeField([{ field: 'typeBySize', value }]);
    };

    render() {
        const { getError, confirmed, type, modifiedFields, underStyle } = this.props;

        return (
            <SelectField
                value={type}
                disabled={!confirmed}
                onChange={(e, index, value) => this.onChange(value)}
                maxHeight={200}
                name='typeBySize'
                floatingLabelText='Type By Size'
                errorText={getError && getError('typeBySize')}
                fullWidth
                input={<input required/>}
                required
                underlineStyle={modifiedFields && modifiedFields.includes('typeBySize') ? underStyle : null}
                autoWidth
            >
                {
                    ['', ...TYPES_BY_SIZE].map((type, i) => {
                        return (<MenuItem
                            key={i}
                            value={type}
                            primaryText={type}
                        />);
                    })
                }
            </SelectField>
        );
    }
}

export default TypeBySize;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TypeBySize.jsx